// extracted by mini-css-extract-plugin
export default {"day":"Day_day__emrmZ"};